/**
 * @module app.portal.userSectorCtrl
 *
 * The var names witch contain loading mean : is a request pending ?
 */

define(['angular', 'lodash'], function(angular, _) {

    function UserSectorCtrl($scope, $rootScope, $uibModal, $log, authService, userService, Notification) {
        authService.updateLoginStatus(); // on verifie que le token est toujours là
        let self = {};
        self.dt = $('#table');

        self.columns = [
            {
                data: 'secteur',
                title: 'Secteur'
            },
            {
                data: 'uid',
                title: 'RDS',
                render: function(data) {
                    const user = userService.findPerson(data);
                    return user ? user.user.displayName : data;
                }
            }
        ];

        self.prepareUpdate = function(secteur) {
            self.sectorToUpdate = secteur;
            _openModalUpdateSector();
        };

        function _openModalUpdateSector(size) {
            let _updateSectorModal = $uibModal.open({
                animation: true,
                templateUrl: 'updateSector.html',
                controller: 'UpdateSectorCtrl',
                controllerAs: 'updateSectorCtrl',
                size: size,
                resolve: {
                    sector: function() {
                        return self.sectors.filter(sector => sector.secteur === self.sectorToUpdate);
                    },
                    rds: function() {
                        return self.rds;
                    }
                }
            });
            _updateSectorModal.result.then(function(data) {
                _confirmUpdate(data.sector);
            });
        }

        function _confirmUpdate(sector) {
            for (let i = 0; i < self.sectors.length; i++) {
                if (self.sectors[i].secteur === self.sectorToUpdate) {
                    self.sectors[i] = sector;
                    userService
                        .updateSector(self.sectors[i])
                        .then(function() {
                            self.table.clear().draw();
                            self.table.rows.add(self.sectors).draw();
                            Notification.success('Secteur mis à jour.');
                        })
                        .catch(function(err) {
                            Notification.error('Une erreur est survenue: ' + err.data);
                            $log.error(err);
                        });
                    break;
                }
            }
        }

        function _getSectors() {
            userService.getSectors().then(res => {
                self.sectors = res;
                self.table = _initDt(self.columns, res);
            });
        }

        function _getRds() {
            return userService.getUsersByRole('RDS').then(res => {
                self.rds = res;
            });
        }

        function _initDt(cols, content) {
            const columns = _.cloneDeep(cols);
            const data = _.cloneDeep(content);

            const dtOptions = {
                data,
                columns,
                info: false,
                filter: true,
                retrieve: true,
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.8/i18n/fr-FR.json'
                },
                paging: false,
                order: [[0, 'asc']],
                select: {
                    style: 'api',
                    toggleable: false
                },
                initComplete: () => {
                    $scope.$emit('initComplete', self.table);

                    self.dt.on('click', 'tr', function() {
                        const row = $scope.userSectorCtrl.table.row(this).data();
                        if (row) {
                            self.prepareUpdate(row.secteur);
                        }
                    });
                }
            };
            return self.dt.DataTable(dtOptions);
        }

        _getRds().then(function() {
            _getSectors();
        });

        return self;
    }

    UserSectorCtrl.$inject = [
        '$scope',
        '$rootScope',
        '$uibModal',
        '$log',
        'authService',
        'userService',
        'Notification'
    ];

    angular.module('app.portal.userSectorCtrl', ['ui-notification']).controller('UserSectorCtrl', UserSectorCtrl);
});
